import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import auth from '../reducers/auth';
import attendees from '../reducers/attendees';
import nav from '../reducers/nav';
import profile from '../reducers/profile';
import booking from '../reducers/booking';
import entities from '../reducers/entities';
import errors from '../reducers/errors';
import services from '../reducers/concierge';
import action_store from '../reducers/action-store';
import env from '../reducers/env';
import listing from '../reducers/listing';
import listings from '../reducers/listings';
import listingPrice from '../reducers/listingPricing';
import calendarPrice from '../reducers/calendarPricing';
import entitlements from '../reducers/entitlements';
import calendar from '../reducers/calendar';
import nux from '../reducers/nux';
import sync from '../reducers/sync';
import spaceTags from '../reducers/spaceTags';
import space from '../reducers/space';
import spaces from '../reducers/spaces';
import modal from '../reducers/modal';
import inventory from '../reducers/inventory';
import payload from '../reducers/payload';
import add_ons from '../reducers/add-ons';
import contract from '../reducers/contracts';
import reviews from '../reducers/reviews';
import banner from '../reducers/banner';
import payouts from '../reducers/payouts';
import flow from '../reducers/flow';
import workflows from '../reducers/workflows';
import payment from '../reducers/payment';
import feeProfiles from '../reducers/feeProfile';
import fees from '../reducers/fees';
import invoices from '../reducers/invoices';

const rootReducer = combineReducers({
  routing: routerReducer,
  auth,
  attendees,
  nav,
  profile,
  booking,
  entities,
  services,
  errors,
  action_store,
  env,
  listing,
  listings,
  entitlements,
  calendar,
  nux,
  sync,
  spaces,
  modal,
  inventory,
  payload,
  add_ons,
  contract,
  reviews,
  listingPrice,
  calendarPrice,
  banner,
  payouts,
  flow,
  workflows,
  space,
  spaceTags,
  payment,
  feeProfiles,
  fees,
  invoices,
  form: formReducer // this needs to have the key of form
});

export default rootReducer;
